import { Suspense, lazy } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import Loading from "../components/Loading";
import homeRoute from "./home";
import publicRoute from "./public";
import supplierRoute from "./supplier";
import systemSettingRoute from "./system";
import requirementRoute from "./requirement";
import orderRoute from "./order";
import contractRoute from "./contract";
import inquiryRoute from "./inquiry";

const App = lazy(() => import("@layouts/App"));

export const routes: Array<RouteConfig> = [
  ...homeRoute,
  ...supplierRoute,
  ...systemSettingRoute,
  ...requirementRoute,
  ...orderRoute,
  ...contractRoute,
  ...inquiryRoute,
];

const Router = () => {
  return (
    <HashRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Suspense fallback={<Loading type="fullscreen" />}>
        <Routes>
          {publicRoute.map((route, i) => (
            <Route key={i} path={route.path} element={<route.component />} />
          ))}
          <Route path="/*" element={<App routes={routes} />} />
        </Routes>
      </Suspense>
    </HashRouter>
  );
};
export default Router;
